// components/CustomSegment.tsx
import { SegmentedType } from "../../types";
import { cn } from "../../utils/utils";

type Props<T extends string> = {
  selected: T;
  config: SegmentedType<T>[];
  onChange: (value: T) => void;
  className?: string;
};

const CustomSegment = <T extends string>({
  config,
  selected,
  onChange,
  className,

}: Props<T>) => {
  return (
    <div
      className={cn(
        "bg-white -mt-4 -mx-6 flex items-center gap-4 px-6",
        className,
      )}
    >
      {config.map((item) => (
        <button
          key={item.key}
          onClick={() => onChange(item.key)}
          className={cn(
            "relative px-1.5 py-3 text-base font-medium transition-colors duration-300",
            selected === item.key
              ? "text-primary"
              : "text-gray-600 hover:text-primary",
          )}
        >
          {item.label}
          <span
            className={cn(
              "absolute left-0 right-0 -bottom-[1px] h-[2px] bg-primary transition-transform duration-300",
              selected === item.key ? "scale-x-100" : "scale-x-0",
            )}
            style={{ transformOrigin: "center" }}
          />
        </button>
      ))}
    </div>
  );
};

export default CustomSegment;
